/**
 * Colorize Markers Constants
 *
 * Score type identifiers used by the colorize-markers panel, both as the radio-button
 * selection and as the converterOptions.fieldID sent with the rendering options.
 */
export const SCORE_TYPE = {
    RISK_SCORE: 'risk_score',
    CONSOLIDATED_RISK_SCORE: 'consolidated_risk_score',
    RISK_LEVEL: 'risk_level',
} as const;

/** The two score types the panel can be toggled between. */
export type ScoreType = typeof SCORE_TYPE.RISK_SCORE | typeof SCORE_TYPE.CONSOLIDATED_RISK_SCORE;

/**
 * The fixed Consolidated Risk Score colour scale (FR-1.47), indexed by score: index 0 is the
 * NOT APPLICABLE grey, 1 to 5 run very low to very high.
 *
 * The order matters to the renderer, not just to the eye. The backend scores this range as 0-5
 * and FixedColorScale picks `colors[round(unit * (colors.length - 1))]`, so six colours over
 * 0-5 makes `round(score / 5 * 5)` land on exactly `colors[score]` - one colour per score, with
 * no interpolation. A five-colour scale has no slot for 0 at all, which is why a score of 0
 * previously drew in the "very low" cream rather than grey.
 */
export const CONSOLIDATED_RISK_SCORE_COLORS = [
    '#646464', '#fff2cc', '#ffd966', '#f4cccc', '#e06666', '#cc0000',
] as const;

/** Markers outside the selected criteria: another profile type, or a score of N/A (FR-1.48). */
export const CONSOLIDATED_RISK_SCORE_DEFAULT_COLOR = '#d3d3d3';

/** The legend's label for each score (FR-1.49). */
export const CONSOLIDATED_RISK_SCORE_LABELS: Record<number, string> = {
    0: 'Not Applicable',
    1: 'Very Low',
    2: 'Low',
    3: 'Moderate',
    4: 'High',
    5: 'Very High',
};
